var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCoolUp = function SvgArrowCoolUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    style: {
      transform: "rotate(180deg)"
    }
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow-cool-up_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1FF66",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow-cool-up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.998 20.7-6.15-6.15.475-.5 5.325 5.325v-7.1h.7V19.4l5.325-5.325.475.475zm-.35-10.425v-3h.7v3zm0-5v-2h.7v2z"
  }))));
};
export default SvgArrowCoolUp;